import { FaSync } from "react-icons/fa";

// export const API_BASE_URL = "http://localhost:4000/api/v1";
// export const API_BASE_URL = "http://192.168.1.52:4000/api/v1";
// export const API_BASE_URL = "http://34.132.54.218/api/method/";
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const PATHS = {
  HOME: "/",
};

export const data = [
  {
    client: "Client 1",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 2",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 3",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 4",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 5",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 6",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 7",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 8",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 9",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 10",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 11",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 12",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 13",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 14",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
  {
    client: "Client 15",
    status: 1,
    username: "user-name",
    password: "**********",
    id: "ID",
    action: <FaSync />,
  },
];

export const columns = [
  { label: "Client", key: "client_name" },
  { label: "Disabled", key: "disabled" },
  { label: "Username", key: "username" },
  { label: "Password", key: "password" },
  { label: "ID", key: "id" },
  { label: "Last Sync", key: "last_income_tax_sync" },
  // { label: "Action", key: "action" },
];

export const ResponseOutstandingFormBlueprint = {
  section1: [
    { label: "Client Name", name: "client_name" },
    { label: "Demand Reference Number", name: "demand_reference_no" },
    { label: "Assessment Year", name: "assessment_year" },
    { label: "Section Code", name: "section_code" },
  ],
  section2: [
    { label: "Rectification Rights", name: "rectification_rights" },
    { label: "Mode Of Service ", name: "mode_of_service" },
    { label: "Response Type", name: "response_type" },
    { label: "Outstanding Demand Amount", name: "outstanding_demand_amount" },
  ],
  section3: [],
  section4: [],
  section5: [],
};

export const NoticeFormBlueprint = {
  section1: [
    { label: "Client Name", name: "client_name" },
    { label: "Document Type", name: "doctype" },
    { label: "Reference ID", name: "ref_id" },
    { label: "Type", name: "type" },
    { label: "Description", name: "description" },
  ],
  section2: [
    { label: "Amount", name: "amount" },
    { label: "Status", name: "notice_status" },
  ],
  section3: [
    { label: "Issued By", name: "issued_by" },
    { label: "Issued Date", name: "issue_date" },
    { label: "Due Date", name: "due_date" },
  ],
  section4: [],
  section5: [],
};

export const TDSNoticeFormBlueprint = {
  section1: [{ label: "Client Name", name: "client_name" }],
  section2: [
    { label: "Financial Year", name: "fy" },
    { label: "Net Payable (Rounded-Off)", name: "net_payable" },
    { label: "Quarter", name: "quarter" },
    { label: "Form Type", name: "form_type" },
    { label: "Issued Date", name: "issue_date" },
    { label: "Notice Status", name: "notice_status" },
    { label: "Processed Demand", name: "processed_demand" },
  ],
  section3: [
    // { label: "Acknowledgement Number", name: "acknowledgement_number" },
    // { label: "Filing Date", name: "filling_date" },
  ],
  section4: [],
  section5: [],

  justificationReportItems: [
    { label: "BSR Code / Receipt Number", name: "bsr_code_receipt_number" },
    {
      label: "Date on which Tax Deposited",
      name: "date_on_which_tax_deposited",
    },
    { label: "Challan Serial Number / DDO", name: "challan_serial_number" },
    { label: "Challan Amount / Transfer Voucher", name: "challan_amount" },
    { label: "CD Record Number", name: "cd_record_number" },
  ],

  panItems: [
    {
      label: "PAN 1",
      name: "pan_1",
    },
    {
      label: "AMT 1",
      name: "amt_1",
    },
    {
      label: "PAN 2",
      name: "pan_2",
    },
    {
      label: "AMT 2",
      name: "amt_2",
    },
    {
      label: "PAN 3",
      name: "pan_3",
    },
    {
      label: "AMT 3",
      name: "amt_3",
    },
  ],
};

export const LoginFailedBluePrint = {
  // "Owner" was removed (2026-07-15): the backend always sends owner="" for
  // failed logins (gst.py), so the field only ever rendered blank.
  section1: [
    { label: "Client Name", name: "client_name" },
  ],
  section2: [],

  section3: [
    { label: "Doc Type", name: "doctype" },
    { label: "Portal", name: "portal" },
    { label: "Reason", name: "reason" },
  ],
  section4: [],
  section5: [],
};

export const AdditionalGSTNoticeBluePrint = {
  section1: [
    { label: "Client Name", name: "client_name" },
    { label: "Document Type", name: "doctype" },
    { label: "Reference ID", name: "ref_id" },
    { label: "Description", name: "description" },
  ],
  section2: [{ label: "Notice Type", name: "type" }],
  section3: [
    { label: "Issued Date", name: "issue_date" },
    { label: "Due Date", name: "due_date" },
    { label: "Amount", name: "amount" },
    { label: "Issued By", name: "issued_by" },
    { label: "Status", name: "notice_status" },
  ],
  section4: [],
  section5: [],
};

export const EproceedingsFormBlueprint = {
  section1: [
    { label: "Client Name", name: "client_name" },
    { label: "Proceeding Name", name: "proceeding_name" },
    { label: "Assessment Year", name: "assessment_year" },
    { label: "Financial Year", name: "financial_year" },
  ],
  section2: [
    { label: "Notice/ Communication Reference ID", name: "notice_din" },
    { label: "Notice Section", name: "notice_section" },
    {
      label: "Document reference ID",
      name: "notice_communication_reference_id",
    },
  ],
  section3: [
    { label: "Response Due Date", name: "response_due_date" },
    { label: "Notice Sent Date", name: "notice_sent_date" },
  ],
  section4: [],
  section5: [
    {
      label: "Previous Replies",
      name: "replies",
      sectionHeader: "Previous Replies",
    },
  ],
};

export const FILE_PREFIX = process.env.REACT_APP_FILE_BASE_URL || process.env.REACT_APP_API_BASE_URL || "";

// Helper: returns the full file URL, skipping FILE_PREFIX for absolute URLs (e.g. S3 presigned URLs)
export const getFileUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${FILE_PREFIX}${url}`;
};

// Appeal feature (GST + Income-Tax appeal drafting/wizards) master switch.
// Default ON so dev + UAT keep it; production sets
// REACT_APP_APPEAL_ENABLED=false in its build .env to hide every Prepare-Appeal
// entry point (buttons + routes). Mirrors the backend APPEAL_FEATURE_ENABLED
// flag (which additionally 404s the appeal APIs). Temporary hold (2026-08-06)
// until Appeal is cleared for production. Disabled ONLY when explicitly "false"
// so a missing/unset var (dev, UAT) keeps the feature available.
export const APPEAL_FEATURE_ENABLED =
  process.env.REACT_APP_APPEAL_ENABLED !== "false";

export const TOTAL_NOTICE_TEXT = "Total Notices";
export const LAST_24_hours_TEXT = "Notices Received in last 3 days";
export const OPEN_NOTICES_TEXT = "Open Notices";
export const OVER_DUE_NOTICES_TEXT = "Over Due";
export const DUE_7_DAYS_TEXT = "Due Within 7 Days";
export const FAILED_LOGIN_TEXT = "Failed Logins";
export const ACTIVE_CLIENTS_TEXT = "Active Clients";
export const DISABLED_CLIENTS_TEXT = "Disabled Clients";
